import * as React from 'react';
import { Button } from '@progress/kendo-react-buttons';
import { ic_nav_back as BackIcon } from 'app/widgets/SVGs';

type Props = {
  selectedFaultCode: any;
  isAuthenticated: boolean;
  onMobileBack: () => void;
  onContactDealer: () => void;
  t: (key: string, options?: any) => string;
};

export function SelectedFaultCodePanel({
  selectedFaultCode,
  isAuthenticated,
  onMobileBack,
  onContactDealer,
  t,
}: Props) {
  if (!selectedFaultCode) return null;

  return (
    <div className="col-sm-6">
      <div className="selected-fault-code">
        <span
          className="back-button back-button-mobile-fault-code"
          onClick={onMobileBack}
        >
          <BackIcon />
        </span>
        <h2>
          {selectedFaultCode.errorType == 'j1939'
            ? `${t('fault_mode_j1939')}: ${selectedFaultCode.j1939Spn}-${
                selectedFaultCode.j1939Fmi
              }`
            : `${t('fault_mode_e_code')}: ${selectedFaultCode.code}`}
        </h2>
        <div className="separator-l"></div>
        <div className="fault-code-texts">
          <div>
            <h5>{t('fault_code_description')}</h5>
          </div>
          <div>{selectedFaultCode.description}</div>
          <div className="separator-l"></div>
          <div>
            <h5>{t('fault_code_action')}</h5>
          </div>
          <div>{selectedFaultCode.provisionalMeasure}</div>
        </div>
        {isAuthenticated && (
          <Button themeColor="primary" onClick={onContactDealer}>
            {t('contact_dealer')}
          </Button>
        )}
      </div>
    </div>
  );
}
